<template>
    <div class="content">
      
        <el-row class="bgW">
            <el-col :span="22">
            <!--检索条件-->
            <el-form class="search" :inline="true" size="mini" :model="search">
                <el-form-item label="客户姓名">
                    <el-input 
                        v-model="search.customer_name" 
                        placeholder="请输入客户姓名" 
                        class="w120"
                        clearable
                    ></el-input>
                </el-form-item>
                
                <el-form-item label="卡项名称">
                    <el-input 
                        v-model="search.service_name" 
                        placeholder="请输入卡项名称" 
                        clearable
                        class="w120"
                    ></el-input>
                </el-form-item>
                
                <el-form-item label="手机号">
                    <el-input 
                        v-model="search.telephone" 
                        placeholder="请输入手机号" 
                        clearable
                        class="w120"
                    ></el-input>
                </el-form-item>
                <el-form-item label="护理师">
                    <el-input 
                        v-model="search.nurse_name" 
                        placeholder="请输入" 
                        clearable
                        class="w120"
                    ></el-input>
                </el-form-item>
                <el-form-item label="星级">
                    <el-select v-model="search.score" clearable class="w120">
                        <el-option
                            v-for="item in options.score"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        />
                    </el-select>
                </el-form-item>
                
                <el-form-item label="市场" v-if="!userInfo.shop_id">
                    <el-select
                    v-model="search.market_id"
                    clearable
                    remote
                    filterable
                    :remote-method="getMarket"
                    placeholder="请输入"
                    class="w120"
                    >
                    <el-option
                        v-for="item in options.market_id"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    />
                    </el-select>
                </el-form-item>
                
                <el-form-item label="门店/门诊" v-if="!userInfo.shop_id">
                    <el-select
                        v-model="search.shop_id"
                        clearable
                        remote
                        filterable
                        :remote-method="remoteMethod"
                        placeholder="请输入"
                        class="w120"
                    >
                    <el-option
                        v-for="item in options.shop_id"
                        :key="item.shopId"
                        :label="item.shopName"
                        :value="item.shopId"
                        />
                    </el-select>
                </el-form-item>      
                
                <el-form-item label="评价时间">
                    <el-date-picker
                        v-model="search.start"
                        type="date"
                        class="w130"
                        placeholder="开始日期"
                        value-format="yyyy-MM-dd"
                    ></el-date-picker>
                    <el-date-picker
                        v-model="search.end"
                        type="date"
                        class="w130"
                        placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                    ></el-date-picker>
                </el-form-item>
            </el-form>
            </el-col>
            <el-col :span="2" style="text-align: right;">
                <el-button type="primary" icon="el-icon-search" size="mini" @click="getList('search')">搜索</el-button>
            </el-col>
        </el-row>
  
        <div class="accountCon">
            <div class="btnBox">
                <el-button
                    type="primary"
                    class="mb10"
                    size="mini"
                    v-if="!userInfo.shop_id"
                    @click="exportData('export')"
                >导出数据</el-button>
                
                <el-button
                    type="primary"
                    class="mb10"
                    size="mini"
                    v-if="!userInfo.shop_id"
                    @click="openScoreSettingDialog"
                >修改评分比例</el-button>
            </div>
            
            <!-- 评分比例设置弹窗 -->
            <el-dialog
                title="修改评分比例设置"
                :visible.sync="scoreSettingDialogVisible"
                width="25%"
                :before-close="handleDialogClose"
            >
                <el-form ref="scoreForm" :model="scoreForm" :rules="scoreRules" label-width="150px">
                    
                    <el-form-item label="差评与好评比例" prop="scoring">
                        <el-input 
                            v-model="scoreForm.scoring" 
                            type="number" 
                            min="1"
                            placeholder="请输入X个好评可以抵1个差评"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="评价赠送积分" prop="points">
                        <el-input 
                            v-model="scoreForm.points" 
                            type="number" 
                            min="0"
                            placeholder="请输入评价赠送的积分"
                        ></el-input>
                    </el-form-item>
                </el-form>
                
                <div slot="footer" class="dialog-footer">
                    <el-button @click="handleDialogClose">取消</el-button>
                    <el-button type="primary" @click="saveScoreSetting" :loading="loading">确定</el-button>
                </div>
            </el-dialog>
            <!-- 回复内容 -->
              <!-- 客服回复弹窗 -->
            <el-dialog
                :title="dialogTitle"
                :visible.sync="dialogVisible"
                width="40%"
                :close-on-click-modal="false"
                class="reply-dialog"
            >
                <div class="feedback-detail">
                    <!-- 评价信息卡片 -->
                    <div class="info-card customer-info">
                        <h3 class="card-title">客户评价信息</h3>
                        <el-row>
                            <el-col :span="6">
                                <div class="feedback-item">
                                    <span class="label">客户姓名：</span>
                                    <span>{{ currentFeedback.customer_name || '未知' }}</span>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <div class="feedback-item">
                                    <span class="label">手机号：</span>
                                    <span>{{ currentFeedback.telephone || '未知' }}</span>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <div class="feedback-item">
                                    <span class="label">市场：</span>
                                    <span>{{ currentFeedback.market_name || '-' }}</span>
                                </div>
                            </el-col>
                            
                            <el-col :span="6">
                                <div class="feedback-item">
                                    <span class="label">门店/门诊：</span>
                                    <span>{{ currentFeedback.shop_name || '-' }}</span>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="6">
                                <div class="feedback-item">
                                    <span class="label">卡项名称：</span>
                                    <span>{{ currentFeedback.service_name || '-' }}</span>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <div class="feedback-item">
                                    <span class="label">服务单号：</span>
                                    <span>{{ currentFeedback.service_id || '-' }}</span>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <div class="feedback-item">
                                    <span class="label">核销员工1：</span>
                                    <span>{{ currentFeedback.nurse_one_name || '-' }}</span>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <div class="feedback-item">
                                    <span class="label">核销员工2：</span>
                                    <span>{{ currentFeedback.nurse_two_name || '-' }}</span>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="6">
                                <div class="feedback-item">
                                    <span class="label">评价分数：</span>
                                    <span>{{ currentFeedback.score || 0 }}/{{ currentFeedback.full_score || 500 }}</span>
                                </div>
                            </el-col>
                            <el-col  :span="12">
                                <div class="feedback-item">
                                    <span class="label">评价时间：</span>
                                    <span>{{ currentFeedback.create_time || '-' }}</span>
                                </div>
                            </el-col>
                        </el-row>
                    
                        <div class="feedback-item evaluation-content-wrapper">
                            <span class="label">评价内容：</span>
                            <div class="evaluation-content">
                                <span v-for="(item, index) in currentFeedback.content" :key="index" class="evaluation-item">
                                    <span>{{ index + 1 }}、</span>
                                    <span class="question">{{ item.question }}：</span>
                                    <span class="answer">{{ formatAnswer([item], item.question) }}</span>；
                                </span>
                            </div>
                        </div>
                    </div>
                    
                    <!-- 回复区域 -->
                    <div class="info-card reply-section" >
                        <h3 class="card-title">回复内容</h3>
                        <el-form 
                            :model="replyForm" 
                            ref="replyForm"
                            label-width="80px"
                        >
                            <el-form-item 
                                label="回复内容" 
                                prop="reply"
                                class="w-full"
                                :rules="[{ required: true, message: '请输入回复内容', trigger: 'blur' }]"
                            >
                                <el-input 
                                    v-model="replyForm.reply" 
                                    type="textarea" 
                                    rows="4" 
                                    placeholder="请输入回复内容，清晰、友好地回应客户的评价..."
                                    class="reply-textarea"
                                ></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false" class="cancel-btn">关闭</el-button>
                    <el-button 
                        type="primary" 
                        @click="submitReply" 
                        class="submit-btn"
                    >
                        提交回复
                    </el-button>
                </div>
            </el-dialog>
            <!--列表-->
            <el-row>
                <el-col :span="24">
                    <el-table
                        :data="list"
                        size="small"
                        border
                        :cell-style="$style.cellStyle"
                        :header-cell-style="$style.rowClass"
                        @selection-change="handleSelectionChange"
                    >
                        <ElTableColumn label="序号" type="index" width="55" />
                        <ElTableColumn label="姓名" prop="customer_name" width="120" fixed="left" />
                        <ElTableColumn label="手机" width="100" prop="telephone" fixed="left" />
                        <ElTableColumn label="评价时间" width="130" prop="create_time" />
                        <ElTableColumn label="服务单号" prop="service_id" width="80" />
                        <ElTableColumn label="卡项名称" prop="service_name" width="150" />
                        <ElTableColumn label="门店/门诊" prop="shop_name" width="90" />
                        <ElTableColumn label="市场" prop="market_name" width="100" />
                        <ElTableColumn label="核销员工1" prop="nurse_one_name" width="90" />
                        <ElTableColumn label="核销员工2" prop="nurse_two_name" width="80" />
                        <ElTableColumn label="评价分数" width="90">
                            <template slot-scope="scope">
                                <div>
                                    <span>{{ scope.row.score }}/{{ scope.row.full_score }}</span>
                                    <div class="score-stars">
                                        <i 
                                            class="el-icon-star" 
                                            v-for="n in 5" 
                                            :key="n"
                                            :class="{ 'star-active': n <= (scope.row.score / scope.row.full_score * 5) }"
                                        ></i>
                                    </div>
                                </div>
                            </template>
                        </ElTableColumn>
                        <ElTableColumn label="是否展示" prop="is_show">
                            <template slot-scope="{ row }">
                                <el-switch
                                v-model="row.is_show"
                                @change="(value) => handleSwitchChange(row, value, 'is_show')"
                                active-color="#33bea7"
                                :active-value="1"
                                :inactive-value="2"
                               :disabled="row.loading ||  ![ 443, 853, 1, 1901, 1917,1916,1927,1737,1752 ].includes(userInfo.id)" 
                                >
                                </el-switch>
                            </template>
                        </ElTableColumn>
                        <ElTableColumn label="是否置顶评价" prop="is_top">
                            <template slot-scope="{ row }">
                                <el-switch
                                v-model="row.is_top"
                                @change="(value) => handleSwitchChange(row, value, 'is_top')"
                                active-color="#33bea7"
                                :active-value="1"
                                :inactive-value="2"
                                :disabled="row.loading ||  ![ 443, 853, 1, 1901, 1917,1916,1927,1737,1752 ].includes(userInfo.id)" 
                                >
                                </el-switch>
                            </template>
                        </ElTableColumn>
                        <!-- 动态渲染问题列 -->
                        <template v-for="(question, index) in questionTitles" >
                            <ElTableColumn 
                                :label="question" 
                                width="150"
                                :key="index"
                            >
                                <template slot-scope="scope">
                                   {{ formatAnswer(scope.row.content, question) }}
                                </template>
                            </ElTableColumn>
                        </template>
                        <ElTableColumn label="回复内容" prop="reply" >
                            <template slot-scope="scope">
                                {{ scope.row.reply || '-'}}
                            </template>
                        </ElTableColumn>

                        <ElTableColumn label="操作" fixed="right">
                            <template slot-scope="{ row }">
                                <span class="theme" @click="goHuifu(row)" >去回复</span>
                            </template>
                        </ElTableColumn>
                    </el-table>

                    <pagination
                        class="page tc mt10"
                        :total="page.total"
                        :page.sync="page.page"
                        :limit.sync="page.limit"
                        @pagination="getList"
                    />
                </el-col>
            </el-row>
        </div>
    </div>
</template>
  
<script>
import { mapGetters } from 'vuex'
import pagination from "@/components/Pagination";
import { clientExport } from "@/api/client";
import { getShopList, getMarketLsit } from "@/api/shop";
import { getRatingList, getEvaluationQuestions,getSystenList, updateRatingShow, updateSystem, getRatingDetail, replyToRating } from "@/api/sys";
  
class Search {
    customer_name = "";      // 客户姓名
    service_name = "";       // 卡项名称
    telephone = "";          // 手机号
    score = "";              // 1-5星级
    market_id = "";          // 市场ID
    shop_id = "";            // 门店ID
    start = this.formatDate(new Date(Date.now() - 10 * 24 * 60 * 60 * 1000));
    end = this.formatDate(new Date());
    nurse_name = "";         // 护理师姓名
      // 格式化日期为 yyyy-MM-dd
    formatDate(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需+1
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
}

class Options {
    shop_id = [];
    score = [
        { label: '好评', value: 1 },
        { label: '中评', value: 2 },
        { label: '差评', value: 3 }
    ];
    market_id = [];
    statusList = [
        { label: '已回复', value: 1 },
        { label: '处理中', value: 2 }
    ];
}

class Page {
    total = 0;
    page = 1;                // 页码
    limit = 10;              // 每页条数
}

// 评分设置表单
class ScoreForm {
    scoring = '';             // 差评与好评比例
    points = '';             // 评价赠送积分
}

export default {
    name: "EvaluationSearch",
    components: {
        pagination
    },
    data() {
        return {
            search: new Search(),
            options: new Options(),
            questionTitles: [], // 存储问题标题列表
            page: new Page(),
            list: [],
            idList: "",
            loading: false,
            
            // 回复弹窗相关
            dialogVisible: false,
            dialogTitle: "评价详情与回复",
            currentFeedback: {},
            isProcessing: false, // 是否为待处理状态(未回复)
            replyForm: {
                reply: '',
            },
            replyImageList: [],
            dialogVisibleImg: false,
            dialogImageUrl: '',
            uploadUrl: '/api/upload/image', // 图片上传接口地址
            
            // 评分设置弹窗相关
            scoreSettingDialogVisible: false,
            scoreForm: new ScoreForm(),
            scoreRules: {
                scoring: [
                    { required: true, message: '请输入差评与好评比例', trigger: 'blur' },
                ],
                points: [
                    { required: true, message: '请输入评价赠送积分', trigger: 'blur' },
                ]
            }
        };
    },
    filters: {
        statusFilter(val) {
            return ["启用", "禁用"][+val];
        }
    },
    computed: {
        ...mapGetters(['userInfo']),
    },
    mounted() {
        this.getList();
    },
    methods: {
        goHuifu(row){
            this.dialogTitle = "评价回复";
            this.replyForm.reply = row.reply || '';
            this.dialogVisible = true;
            this.currentFeedback = row;
            this.isProcessing = true;
        },
        
        handleSwitchChange(row, value, field) {
            
            let params = {
                id: row.id, 
                [field]: value,
                operator:this.userInfo.id
            }
        
            updateRatingShow(params)
                .then(res => {
                    if (res.code === 200) {
                        this.$message.success('状态更新成功');
                        row[field] = value;
                    } else {
                        this.$message.error(res.msg || '状态更新失败');
                    }
                })
                .catch(error => {
                    this.$message.error('网络错误，更新失败');
                })
                .finally(() => {
                    row.loading = false;
                });
        },

      
        // 获取列表
        getList(option) {
            if (option === "search") this.page = new Page();
            const params = {
                ...this.search,
                page: this.page.page,
                page_size: this.page.limit,
                is_export: 0
            };
            getRatingList(params).then(
                res => {
                    this.list = res.data; 
                    this.page.total = res.total;
                    // 从第一条数据中提取问题标题
                    if (this.list.length > 0 && this.list[0].content) {
                        this.questionTitles = this.list[0].content.map(item => item.question);
                    }
                }
            );
        },
        // 搜索市场
        getMarket(e) {
            getMarketLsit({ page:1, limit:100000, marketName:e }).then(res => {
                this.options.market_id = res;
            })
        },
        exportData(option) {
            if (option === "export") this.page = new Page();
            const params = {
                ...this.search,
                is_export: 1
            };
            getRatingList(params).then(
                res => {
                    window.open(res.url);
                }
            );
        },
  
        remoteMethod(e) {
            getShopList({ page: 1, limit: 100000, shopName: e }).then(res => {
                this.options.shop_id = res.list;
            });
        },

        tapBtn(routerName, id) {
            const query = { id: id, activeName: "first" };
            let route = this.$router.resolve({ name: routerName, query });
            window.open(route.href, '_blank');
        },
        
        // 提交回复
        submitReply() {
            this.$refs.replyForm.validate(valid => {
                if (valid) {
                    this.loading = true;
                    // 准备提交的数据
                    const params = {
                        id: this.currentFeedback.id,
                        ...this.replyForm,
                        reply_id: this.userInfo.id,
                    };
                    
                    updateRatingShow(params).then(res => {
                        if (res.code === 200) {
                            this.$message.success('回复成功');
                            this.dialogVisible = false;
                            // 刷新列表
                            this.getList();
                        } else {
                            this.$message.error(res.msg || '回复失败');
                        }
                    }).catch(err => {
                        this.$message.error('网络错误，回复失败');
                        console.error(err);
                    }).finally(() => {
                        this.loading = false;
                    });
                }
            });
        },
        handleSelectionChange(val) {
            this.idList = val.map(i => {
                return i.id;
            });
        },
        
        openScoreSettingDialog() {
            getSystenList().then(res => {
                this.scoreForm.scoring = res.scoring;
                this.scoreForm.points = res.points;
            })
            this.scoreSettingDialogVisible = true;
        },
        
        handleDialogClose() {
            this.scoreSettingDialogVisible = false;
        },
        
        saveScoreSetting() {
            this.$refs.scoreForm.validate(valid => {
                if (valid) {
                    this.loading = true;
                    const params = {
                        id: 1,
                        scoring: this.scoreForm.scoring, 
                        points: this.scoreForm.points,
                        operator: this.userInfo.id
                    };
                    
                    updateSystem(params)
                        .then(res => {
                            this.$message.success('评分比例设置保存成功');
                            this.scoreSettingDialogVisible = false;
                            this.loading = false;
                        })
                        .catch(error => {
                            console.error(error);
                            this.loading = false;
                        });
                }
            });
        },
        
       formatAnswer(content, question) {
            if (!content || !question) return '';
            const item = content.find(item => item.question === question);
            if (!item) return '';
            
            const answer = item.answer;
            // 判断是否为纯数字（包括数字类型和字符串类型的数字）
            // const isPureNumber = (typeof answer === 'number' && !isNaN(answer)) || 
            //                     (typeof answer === 'string' && /^\d+$/.test(answer.trim()));
            
            // return isPureNumber ? `${answer}星` : answer;
            return answer;
        }
    }
};
</script>
  
<style lang="scss" scoped>
.mainColor {
    color: #2dc0a3;
}
.content {
    height: calc(100% - 56px);
    overflow-y: auto;
}
.bgW {
    background: #fff;
    border-radius: 3px;
    padding: 10px;
    margin-bottom: 20px;
}
  
.accountCon {
    background: #fff;
    padding: 0px 10px 80px;
    .btnBox {
        display: flex;
        gap: 10px; // 按钮之间的间距
    }
}

// 评分星星样式
.score-stars {
    color: #e4e4e4;
    margin-top: 4px;
    
    .star-active {
        color: #f5a623;
    }
}

// 回复弹窗样式优化
.reply-dialog {
    .el-dialog__body {
        max-height: 70vh;
        overflow-y: auto;
        padding: 20px;
    }
}

// 信息卡片样式
.info-card {
    background: #f9f9f9;
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 20px;
    border: 1px solid #eee;
    
    &.customer-info {
        border-left: 3px solid #2dc0a3;
    }
    
    &.reply-section {
        border-left: 3px solid #409eff;
        
        &.resolved-content {
            border-left: 3px solid #67c23a;
        }
    }
    
    .card-title {
        margin-top: 0;
        margin-bottom: 15px;
        color: #333;
        font-size: 16px;
        font-weight: 500;
        padding-bottom: 8px;
        border-bottom: 1px dashed #eee;
    }
}

// 评价详情样式
.feedback-detail {
    .feedback-item {
        margin-bottom: 12px;
        line-height: 1.8;
        
        .label {
            display: inline-block;
            font-weight: 500;
            color: #666;
        }
        
        &.evaluation-content-wrapper {
            margin-bottom: 0;
            
            .evaluation-content {
                background: #fff;
                padding: 10px;
                border-radius: 4px;
                border: 1px solid #f0f0f0;
                
                .evaluation-item {
                    margin-bottom: 8px;
                    padding-bottom: 8px;
                    border-bottom: 1px dashed #f0f0f0;
                    
                    &:last-child {
                        border-bottom: none;
                        margin-bottom: 0;
                        padding-bottom: 0;
                    }
                    
                    .question {
                        font-weight: 500;
                    }
                    
                    .answer {
                        margin-left: 5px;
                    }
                }
            }
        }
        
        &.reply-meta {
            color: #888;
            font-size: 13px;
        }
        
        .reply-content-text {
            background: #fff;
            padding: 10px;
            border-radius: 4px;
            border: 1px solid #f0f0f0;
            line-height: 1.6;
            display: inline-block;
            min-width: calc(100% - 100px);
        }
        
        .image-group {
            display: inline-flex;
            flex-wrap: wrap;
            margin-top: 5px;
            gap: 10px;
        }
        
        .reply-image {
            width: 80px; 
            height: 80px; 
            margin-right: 10px; 
            cursor: pointer;
            transition: transform 0.2s ease;
            
            &:hover {
                transform: scale(1.05);
            }
        }
    }
}

// 回复表单样式
.reply-textarea {
    width: 100%;
    border-radius: 4px;
    transition: border-color 0.2s;
    
    &:focus {
        border-color: #409eff;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
    }
}

.w-full {
    width: 100%;
}

.upload-hint {
    color: #999;
    font-size: 12px;
}

// 按钮样式优化
.dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    
    .cancel-btn {
        transition: all 0.2s;
        
        &:hover {
            background-color: #f5f5f5;
        }
    }
    
    .submit-btn {
        transition: all 0.2s;
        
        &:hover {
            opacity: 0.9;
        }
    }
}

// 比例输入框样式
.ratio-input {
    display: flex;
    align-items: center;
    width: 100%;
    
    .ratio-input-item {
        width: 40%;
    }
    
    .ratio-separator {
        width: 20%;
        text-align: center;
        font-size: 16px;
    }
}
  
.describe{
    padding-left: 10px;
    .describeText{
        color: #666;
    }
    .dataMsg {
        line-height: 30px;
        span {
            margin-left: 0px;
            font-weight: bold;
        }
    }
}

// 操作按钮样式
.theme {
    color: #2dc0a3;
    cursor: pointer;
    margin-right: 15px;
    &:hover {
        text-decoration: underline;
    }
}
  
</style>
